import React from 'react';
import { TypedMemo } from '../../common/types';
import { OwnershipMatrixModal } from './OwnershipMatrixModal';
import { ConnectionProfileUrlModal } from './ConnectionProfileUrlModal';
import { ConnectServiceModal } from './ConnectServiceModal';
import { CatalogConnections } from './useCatalogConnections';
import { SessionCaptureHandoffModal } from './sessionCapture/SessionCaptureHandoffModal';
import { SessionCaptureArtistModal } from './sessionCapture/SessionCaptureArtistModal';

interface CatalogConnectionModalsProps {
  accountId: number;
  connections: CatalogConnections;
}

/**
 * The modals of the connections panel: the ownership matrix, profile url, connect, the phone
 * handoff and the artist picker of Ditto Music.
 */
const CatalogConnectionModalsComponent: React.FC<CatalogConnectionModalsProps> = ({ accountId, connections: c }) => (
  <>
    <OwnershipMatrixModal isOpen={c.isMatrixOpen} closeModal={c.closeMatrix} />
    <ConnectionProfileUrlModal
      connection={c.profileUrlFor}
      closeModal={c.closeProfileUrl}
      onSave={c.connections.saveProfileUrl}
      isLoading={c.connections.isWriting}
      error={c.connections.writeError}
    />
    <ConnectServiceModal
      accountId={accountId}
      connection={c.connectFor}
      closeModal={c.closeConnect}
      onRequest={c.connections.requestConnection}
      onUseProfileUrl={c.onEditProfileUrl}
      isLoading={c.connections.isWriting}
      error={c.connections.writeError}
      callbackFailure={c.callbackFailure}
    />
    <SessionCaptureHandoffModal accountId={accountId} connection={c.handoffFor} onClose={c.closeHandoff} />
    <SessionCaptureArtistModal
      connection={c.artistPickFor}
      portal={c.portal}
      onPicked={c.onArtistPicked}
      onClose={c.closeArtistPick}
    />
  </>
);

export const CatalogConnectionModals = TypedMemo(CatalogConnectionModalsComponent);
